// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import config from '../../../../../share/config';
import cstmTable from '../../../../../share/components/vue/PaginationTable';
import inputValidator from '../../../../../share/util/inputValidator';
import util from '../../../../../share/util/utils';
import error from '../../../../../common/nodejs/errors';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  EXECUTE: 'execute',
  ADDRESS_INPUT: 'addressInput',
  DATA_INPUT: 'dataInput',
  FAILED: 'failed'
};

export default {
  name: 'requirementSpECM004',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      systemId: '',
      selectedIndex: -1, // 選択行
      selectedData: {}, // 選択セル
      addrDatBitTempList: [], // 内部保持用アドレス指定データ一覧
      addressInputData: '', // アドレス入力値
      dataInputData: '', // データ入力値
      isAlert: {}, // アラート情報
      addrDatBitList: [], // アドレス指定データ一覧
      modal_special_requirement_ECM4: false
    };
  },

  props: {
    workSupportId: { type: Number, default: '', required: true },
  },

  /** テーブル部品定義 */
  components: {
    'cstm-table': cstmTable,
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId,
    }),

    /** ダイアログのヘッダー色 */
    headerColor() {
      switch (this.phase) {
        case PHASE.START:
        case PHASE.EXECUTE:
        case PHASE.ADDRESS_INPUT:
        case PHASE.DATA_INPUT:
          return 'secondary';
        case PHASE.FAILED:
          return 'danger';
        default:
          return 'secondary';
      }
    },

    /** ダイアログのヘッダー文言 */
    headerTitle: {
      get() {
        switch (this.phase) {
          case PHASE.START:
            return 'individual.common_title_execution';
          case PHASE.EXECUTE:
          case PHASE.ADDRESS_INPUT:
          case PHASE.DATA_INPUT:
            return 'message.common_title_confirmation';
          case PHASE.FAILED:
            return 'message.common_title_error';
          default:
            return 'message.common_title_error';
        }
      }
    },

    /** アドレス指定データ一覧ヘッダー定義 */
    addrDatBitColumns() {
      return [
        { name: 'addr', label: 'individual.label_header_addr', useDataSelect: true },
        { name: 'dat', label: 'individual.label_header_dat', useDataSelect: true },
        { name: 'bit', label: 'individual.label_header_bit' },
      ];
    },

    /** フッターの表示制御 */
    isHideFooter: {
      get() {
        return this.phase === PHASE.EXECUTE;
      }
    }
  },

  mounted() {
    // 初期化処理を呼び出す
    this.init();
  },

  beforeUnmount() {
    // onkeydown の再登録
    document.onkeydown = (event) => {
      return util.checkSSM5ValidCharacters(event);
    };
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    async init() {
      this.modal_special_requirement_ECM4 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // 待機処理を呼び出す
      this.standbyPostGet();
    },

    //----- htmlイベント処理 -----------------------------------------------//

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_special_requirement_ECM4 = false;
    },

    /** 画面を閉じるイベント */
    async eventClose() {
      // 終了処理を呼び出す
      await this.exitPostGet();
      // 画面を閉じる
      this.closeWizard();
    },

    /** アドレス指定データ一覧初期データ生成処理 */
    setDefaultAddrDatBitList() {
      // 内部保持用アドレス指定データ一覧を初期化
      this.addrDatBitTempList = [];
      // デフォルト値「-(未入力状態)」を8件設定
      for (let i = 0; i < 8; i++) {
        this.addrDatBitTempList.push({ addr: '-', dat: '-', bit: '-' });
      }
    },

    /** キー入力イベント設定処理 */
    setOnKeyDownEvent() {
      // 本機能用のキー入力イベントを設定
      document.onkeydown = (event) => {
        // スピナー非表示時にキー入力された場合
        if (event && !this.isLoading) {
          switch (this.phase) {
            case PHASE.ADDRESS_INPUT:
            case PHASE.DATA_INPUT:
              // アドレス入力画面、または、データ入力画面の場合
              if (event.code === 'Escape') { // 「ESC」
                // 入力キャンセル処理
                this.eventExecute();
              }
              break;
            case PHASE.EXECUTE:
              // 実行画面の場合
              switch (event.code) {
                case 'ArrowUp': // 「↑」
                  // １つ上方向の行を選択状態にする
                  if (this.selectedIndex > 0) {
                    this.selectedIndex = this.selectedIndex - 1;
                  } else {
                    this.selectedIndex = this.addrDatBitList.length - 1;
                  }
                  this.setHighLight();
                  break;
                case 'ArrowDown': // 「↓」
                  // １つ下方向の行を選択状態にする
                  if (this.selectedIndex < this.addrDatBitList.length - 1) {
                    this.selectedIndex = this.selectedIndex + 1;
                  } else {
                    this.selectedIndex = 0;
                  }
                  this.setHighLight();
                  break;
                case 'F12': // 「F12」
                  // 開発者ツールの表示抑制
                  event.preventDefault();
                  // 終了処理を呼び出し、画面を閉じる
                  this.eventClose();
                  break;
              }
          }
        }
      };
    },

    /** 選択セルの行ハイライト設定 */
    setHighLight() {
      this.addrDatBitList.forEach((item, index) => {
        if (this.selectedIndex === index) {
          item.fieldSpec = {};
          item.fieldSpec.addr = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.dat = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.bit = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** アドレス指定データ一覧セルクリックイベント */
    clickCell(data) {
      // 選択行を保持
      this.selectedIndex = data.rowIndex;
      // ハイライトを設定
      this.setHighLight();
      // 各入力画面への遷移判定
      switch (data.columnName) {
        case 'addr': // ADDR列セル
          // 選択セルを保持
          this.selectedData = data;
          // 初期入力値を設定
          this.addressInputData = data.value !== '-' ? data.value : '00000000';
          // アラート情報をクリア
          this.clearInputAlert();
          // アドレス入力画面に遷移
          this.showAddressInput();
          break;
        case 'dat': // DAT列セル
          // ADDR列が入力済の場合
          if (this.addrDatBitTempList[this.selectedIndex].addr !== '-') {
            // 選択セルを保持
            this.selectedData = data;
            // 選択行アドレス値を保持
            this.addressInputData = this.addrDatBitTempList[this.selectedIndex].addr;
            // 初期入力値を設定
            this.dataInputData = data.value !== '-' ? data.value : '';
            // アラート情報をクリア
            this.clearInputAlert();
            // データ入力画面に遷移
            this.showDataInput();
          }
          break;
      }
    },

    /** アドレス入力画面OKボタンクリックイベント */
    async clickAddressInputExecute() {
      // バリデーションチェック
      if (!this.validate(this.addressInputData, 8)) {
        // エラーの場合、以降の処理を行わない
        return;
      }

      // '0'パディング設定(空白の場合はデフォルト入力値になる)
      this.addressInputData = ('00000000' + this.addressInputData).slice(-8);
      // アドレス入力値を内部保持用アドレス指定データに反映
      this.addrDatBitTempList[this.selectedIndex].addr = this.addressInputData;
      // 読み出しアドレス配列を生成(重複アドレスを省いた入力済アドレス)
      const memoryAddressList = Array.from(new Set(
        this.addrDatBitTempList.map(row => row.addr).filter(addr => addr !== '-')
      ));
      // アドレス指定データ読み出し処理を呼び出す
      await this.readPostGet(memoryAddressList);
    },

    /** データ入力画面OKボタンクリックイベント */
    async clickDataInputExecute() {
      // バリデーションチェック
      if (!this.validate(this.dataInputData, 2)) {
        // エラーの場合、以降の処理を行わない
        return;
      }

      // '0'パディング設定(空白の場合はデフォルト入力値になる)
      this.dataInputData = ('00' + this.dataInputData).slice(-2);
      // アドレス指定データ書き込み処理を呼び出す
      await this.writePostGet();
    },

    /**
     * 共通バリデーションチェック
     * @param {string} inputData 入力値
     * @param {number} maxLength 入力最大文字数
     */
    validate(inputData, maxLength) {
      this.isAlert.data = inputValidator.validateCommons(
        inputData, false, maxLength, /^[a-fA-F0-9]*$/
      );
      return this.isAlert.data.valid === null;
    },

    /** 入力画面アラートクリアイベント */
    clearInputAlert() {
      // アラート情報をクリア
      this.isAlert = {
        data: { valid: null, msg: '' }
      };
    },

    /**
     * 各入力画面キャンセルボタンクリックイベント
     * 各入力画面「ESC」キー入力イベント
     */
    eventExecute() {
      // 実行画面を表示
      this.showExecute();
    },

    //----- PHASE操作処理 -----------------------------------------------//

    /** 実行表示処理 */
    showExecute() {
      this.phase = PHASE.EXECUTE;
      // アドレス指定データ一覧を初期化
      this.addrDatBitList = [];
      // $nextTickによりDOMが更新後に処理が可能
      this.$nextTick(() => {
        // アドレス指定データ一覧にデータ設定
        this.addrDatBitList = this.addrDatBitTempList;
        // ハイライトを初期設定(各入力画面から遷移時に反映)
        this.setHighLight();
      });
    },

    /** アドレス入力表示処理 */
    showAddressInput() {
      this.phase = PHASE.ADDRESS_INPUT;
    },

    /** データ入力表示処理 */
    showDataInput() {
      this.phase = PHASE.DATA_INPUT;
    },

    /** 通信エラー表示処理 */
    showFailed() {
      this.phase = PHASE.FAILED;
    },

    //----- バックエンドAPI実行処理 -----------------------------------------------//

    /**
     * 待機処理
     */
    async standbyPostGet() {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            is_special: true,
            type: 'standby'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // レスポンスが取得できた場合
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            // [成功]
            // キー入力イベント設定処理
            this.setOnKeyDownEvent();
            // アドレス指定データ一覧初期データ生成処理
            this.setDefaultAddrDatBitList();
            // 実行画面に遷移
            this.showExecute();
          } else {
            // [成功以外]
            switch (response.data.async_code) {
              case error.WSP_DEVELOP_HEX_NON_DEFAULT_NG_ERROR:
                // [NonDefaultSession遷移: 否定応答]
                // キー入力イベント設定処理
                this.setOnKeyDownEvent();
                // アドレス指定データ一覧初期データ生成処理
                this.setDefaultAddrDatBitList();
                // 実行画面に遷移
                this.showExecute();
                break;
              case error.WSP_DEVELOP_HEX_SECURITY_ACCESS_ERROR:
                // [セキュティアクセス: 異常終了]
                // 終了処理を呼び出す
                await this.exitPostGet();
                // 通信エラー画面に遷移
                this.showUnexpectedError();
                break;
              default:
                // [上記以外のエラー]
                // 通信エラー画面に遷移
                this.showUnexpectedError();
                break;
            }
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * アドレス指定データ読み出し処理
     * @param {Array} memoryAddressList 入力済アドレス配列
     */
    async readPostGet(memoryAddressList) {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            is_special: true,
            type: 'read',
            memory_address_list: memoryAddressList // 入力済アドレス配列
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // レスポンスが取得できた場合
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            // [成功]
            // 内部保持用アドレス指定データの全行を変更
            const rowList = response.data.user_data.address_list;
            for (let i = 0; i < this.addrDatBitTempList.length; i++) {
              // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
              /* eslint-disable max-depth */
              if (this.addrDatBitTempList[i].addr !== '-') {
                // addrの大文字／小文字を考慮して対象行を特定
                const row = rowList.find(item => item.addr === this.addrDatBitTempList[i].addr.toUpperCase());
                if (row) {
                  // 該当行のアドレス対応値に更新
                  // addrは大文字／小文字のパターンがあるため、入力済アドレスをそのまま適用
                  this.addrDatBitTempList[i].dat = row.dat;
                  this.addrDatBitTempList[i].bit = row.bit;
                } else {
                  // 該当行のアドレスが見つからなければ、デフォルト値「-(未入力状態)」を設定
                  this.addrDatBitTempList[i].addr = '-';
                  this.addrDatBitTempList[i].dat = '-';
                  this.addrDatBitTempList[i].bit = '-';
                }
              }
            }
          } else {
            // [成功以外]
            // 内部保持用アドレス指定データの全行を変更
            this.setDefaultAddrDatBitList();
          }
          // 実行画面に遷移
          this.showExecute();
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * アドレス指定データ書き込み処理
     */
    async writePostGet() {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            is_special: true,
            type: 'write',
            memory_address: this.addressInputData, // アドレス入力値
            data_record: this.dataInputData // データ入力値
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // レスポンスが取得できた場合
          if (response.data.status === config.STATUS_WSP_COMPLETED) {
            // [成功]
            // 内部保持用アドレス指定データの対象行の値を変更
            // addrは大文字／小文字のパターンがあるため、入力済アドレスをそのまま適用
            this.addrDatBitTempList[this.selectedIndex].dat = response.data.user_data.dat;
            this.addrDatBitTempList[this.selectedIndex].bit = response.data.user_data.bit;
          } else {
            // [成功以外]
            // 内部保持用アドレス指定データの対象行の値を変更
            this.addrDatBitTempList[this.selectedIndex].addr = '-';
            this.addrDatBitTempList[this.selectedIndex].dat = '-';
            this.addrDatBitTempList[this.selectedIndex].bit = '-';
          }
          // 実行画面に遷移
          this.showExecute();
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 終了処理
     */
    async exitPostGet() {
      try {
        this.isLoading = true;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            is_special: true,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * API 通信で通信バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 通信エラー画面に遷移
      this.showFailed();
    },

  }
};